import { v4 as uuid } from 'uuid';

import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { MailTemplateBO, withModule } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { EnumTranslatorBase, LabeledEnumValue, LabeledEnumValueConverter, MailTemplateKind, MailTemplateModel } from '@skylab-shared/dataModel';

import { MailTemplateRepository, MailTemplateRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EnumTranslator, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FillEmptyDirective, FocusByDirective, FormContainerComponent, HelpInPlaceComponent, HelpInPlaceData, SelectValueAccessorDirective, TextareaValueAccessorDirective, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationAreaComponent, ValidationSourceDirective, IconComponent } from '@skylab-angular-shared/ui';


import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { MailTemplateAutotextService } from '../../hintbox/mail-template-autotext/mail-template.service';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';
import { SenderNamePlaceholder } from '../send-email/send-email-dialog-base';

export interface MailTemplateDialogResult {
    id: number;
    version: string;
}

interface MailTemplateViewModel extends DictionaryDialogViewModelBase<MailTemplateBO> {
    wasDefault: boolean;
    mailTemplateTypes: LabeledEnumValue[];
    mailTemplateTypesConverter: LabeledEnumValueConverter<MailTemplateKind>;
    getMailTemplateAutotextsHintobxData(): HelpInPlaceData;
    parametersAreaId: string;
    patternAreaId: string;
    senderName: {
        value: string;
    };
    senderNamePlaceholder: string;
    isEditingTemplateActive: boolean;
}
@Component({
    selector: 'skl-mail-template-dialog',
    templateUrl: './mail-template-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, ValidationAreaComponent, BooleanValueAccessorDirective, FormsModule, ValidateDirective, FocusByDirective, SelectValueAccessorDirective, TextValueAccessorDirective, FillEmptyDirective, HelpInPlaceComponent, TextareaValueAccessorDirective, ButtonComponent, TranslatePipe, IconComponent]
})
export class MailTemplateDialogComponent extends DictionaryDialogComponentBase
<
MailTemplateModel,
MailTemplateBO,
MailTemplateRepositoryBase,
MailTemplateViewModel
> {
    public constructor(
        @Inject(MailTemplateRepository) MailTemplateRepository: MailTemplateRepositoryBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(EventBus) eventBus: EventBusBase,
        @Inject(EnumTranslator) private readonly enumTranslator: EnumTranslatorBase,
        dialogService: DialogInsService,
        toastService: ToastService,
        commandBus: CommandBus,
        private readonly mailTemplateService: MailTemplateAutotextService
    ) {
        super(MailTemplateRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }

    protected override async prepareDataAsync(): Promise<void> {
        await super.prepareDataAsync();
        this.viewModel.wasDefault = this.viewModel.bo.model.default;
        this.viewModel.bo.model.kind = this.viewModel.bo.model.kind || MailTemplateKind.SingleFile;
    }

    protected override getInitialState(): MailTemplateViewModel {
        const self = this;

        return {
            ...super.getInitialState(),
            wasDefault: false,
            mailTemplateTypes: this.enumTranslator.getLabeledEnumValueArray(MailTemplateKind),
            mailTemplateTypesConverter: new LabeledEnumValueConverter(this.enumTranslator, MailTemplateKind),
            getMailTemplateAutotextsHintobxData: () => ({
                hintbox: {
                    titleText: this.l10n._T('scenes.configuration.shared.mail-template.hintbox.autotexts.title'),
                    content: this.mailTemplateService.getFormattedContent(this.viewModel.bo.model.kind),
                },
                tooltip: this.l10n._T('scenes.configuration.shared.mail-template.hintbox.autotexts.tooltip')
            }),
            parametersAreaId: uuid(),
            patternAreaId: uuid(),
            senderNamePlaceholder: SenderNamePlaceholder,
            senderName: {
                get value(): string {
                    return self.viewModel.bo.model.senderName || self.viewModel.senderNamePlaceholder;
                },
                set value(value: string) {
                    self.viewModel.bo.model.senderName = value;
                }
            },
            isEditingTemplateActive: withModule('MailTemplateEditing')
        };
    }
}
